import { Icon } from '@iconify/react';
import SearchableDropdown from '../../../../components/SearchableDropdown';
import { VISITOR_TYPES, typeLabel } from '../visitorConstants';

// Blocked vs active is one list filtered, not three datasets — the API exposes
// it as a single is_blocked query param, so these tabs only set that value.
const STATUS_TABS = [
    { value: '', label: 'All' },
    { value: 'false', label: 'Active' },
    { value: 'true', label: 'Blocked' },
];

const TYPE_OPTIONS = VISITOR_TYPES.map(t => ({ value: t, label: typeLabel(t) }));

const VisitorFilters = ({
    search,
    onSearchChange,
    visitorType,
    onVisitorTypeChange,
    blockedFilter,
    onBlockedFilterChange,
    hasFilters,
    onClear,
}) => (
    <>
        <div className="tw-px-4 tw-pt-3 tw-flex tw-items-center tw-gap-1 tw-border-b tw-border-gray-100">
            {STATUS_TABS.map(tab => (
                <button
                    key={tab.value || 'all'}
                    type="button"
                    onClick={() => onBlockedFilterChange(tab.value)}
                    className={`tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-border-b-2 tw-transition-colors ${blockedFilter === tab.value
                        ? 'tw-border-sky-600 tw-text-sky-700'
                        : 'tw-border-transparent tw-text-gray-500 hover:tw-text-gray-700'
                        }`}
                >
                    {tab.label}
                </button>
            ))}
        </div>

        <div className="tw-p-4 tw-border-b tw-border-gray-100 tw-bg-gray-50/50 tw-grid tw-grid-cols-1 sm:tw-grid-cols-4 tw-gap-3">
            <div className="sm:tw-col-span-2 tw-relative">
                <Icon icon="mdi:magnify" className="tw-absolute tw-left-3 tw-top-1/2 tw--translate-y-1/2 tw-text-gray-400" />
                <input
                    type="text"
                    placeholder="Search by name, phone, email or company..."
                    value={search}
                    onChange={e => onSearchChange(e.target.value)}
                    maxLength={100}
                    className="tw-w-full tw-pl-9 tw-pr-8 tw-py-2 tw-text-xs tw-border tw-border-gray-200 tw-rounded-md focus:tw-outline-none focus:tw-border-sky-500"
                />
                {search && (
                    <button
                        type="button"
                        onClick={() => onSearchChange('')}
                        title="Clear search"
                        className="tw-absolute tw-right-2 tw-top-1/2 tw--translate-y-1/2 tw-text-gray-400 hover:tw-text-gray-600"
                    >
                        <Icon icon="mdi:close-circle" />
                    </button>
                )}
            </div>

            {/* The dropdown reports "cleared" as the literal 'all'; this screen
                uses '' so the param can simply be dropped from the query. */}
            <SearchableDropdown
                small
                value={visitorType}
                onChange={(v) => onVisitorTypeChange(v === 'all' ? '' : v)}
                options={TYPE_OPTIONS}
                placeholder="All Types"
            />

            <button
                type="button"
                onClick={onClear}
                disabled={!hasFilters}
                className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-xs tw-font-medium tw-text-gray-600 tw-border tw-border-gray-200 tw-bg-white tw-rounded-md hover:tw-bg-gray-50 disabled:tw-opacity-40 disabled:hover:tw-bg-white"
            >
                <Icon icon="mdi:filter-remove-outline" className="tw-text-base" />
                Clear filters
            </button>
        </div>
    </>
);

export default VisitorFilters;
